import api, { openApi } from "../../services/api";

const useSettings = () => {
  const getAll = async (params) => {
    const { data } = await api.request({
      url: "/settings",
      method: "GET",
      params,
    });
    return data;
  };

  const update = async (data) => {
    const { data: responseData } = await api.request({
      url: `/settings/${data.key}`,
      method: "PUT",
      data,
    });
    console.log(responseData);
    return responseData;
  };

  const get = async (param) => {
    const { data } = await api.request({
      url: `/setting/${param}`,
      method: "GET",
    });
    return data;
  };

  const getPublicSetting = async (key, companyId = null) => {
    const params = companyId ? { companyId } : {};
    const { data } = await openApi.request({
      url: `/public-settings/${key}`,
      method: "GET",
      params,
    });
    return data;
  };

  const getAISecretStatus = async () => {
    const { data } = await api.request({
      url: "/settings/ai/secret-status",
      method: "GET"
    });

    return data;
  };

  const updateAISecret = async (anthropicApiKey) => {
    const { data } = await api.request({
      url: "/settings/ai/secret",
      method: "PUT",
      data: {
        anthropicApiKey
      }
    });

    return data;
  };

  const getMetaEmbeddedSignupSecretStatus = async () => {
    const { data } = await api.request({
      url: "/settings/meta/embedded-signup/secret-status",
      method: "GET"
    });

    return data;
  };

  const updateMetaEmbeddedSignupSecret = async (metaAppSecret) => {
    const { data } = await api.request({
      url: "/settings/meta/embedded-signup/secret",
      method: "PUT",
      data: {
        metaAppSecret
      }
    });

    return data;
  };

  return {
    getAll,
    update,
    get,
    getPublicSetting,
    getAISecretStatus,
    updateAISecret,
    getMetaEmbeddedSignupSecretStatus,
    updateMetaEmbeddedSignupSecret
  };
};

export default useSettings;
